import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import DeckGL from "@deck.gl/react";
import "mapbox-gl/dist/mapbox-gl.css";
import { Map } from "react-map-gl";

export default function DeckglBase({
  layers,
  setDeckGLRef,
  parameters,
  onViewStateChange: externalOnViewStateChange
}) {

  const initialViewState = {
    "latitude": -36.82,
    "longitude": -73.05,
    "bearing": 0,
    "zoom": 11,
    "pitch": 0,
    "normalize": true,
  };

  const [viewState, setViewState] = useState(initialViewState);
  const [dimensions, setDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });

  const viewStateRef = useRef(viewState);
  const ref = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    ref.current && setDeckGLRef(ref);
    // eslint-disable-next-line react-hooks/exhaustive-deps

    if (ref.current) {
      const gl = ref.current.deckRenderer?.gl;
      console.log('Using WebGL version:', gl instanceof WebGL2RenderingContext ? 'WebGL2' : 'WebGL1');
    }
  }, [ref]);

  useEffect(() => {
    viewStateRef.current = viewState;
  }, [viewState]);
  
  // fix deck view rotate
  useEffect(() => {
    document
      // ! a more aggressive method which prevents all right click context menu [ OLD: .getElementById("deckgl-wrapper")]
      .addEventListener("contextmenu", (evt) => evt.preventDefault());

    // Listener para actualizar dimensiones
    const handleResize = () => {
      if (containerRef.current) {
        setDimensions({
          width: containerRef.current.clientWidth,
          height: containerRef.current.clientHeight
        });
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Llamar inicialmente

    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onViewStateChange = ({ viewState, interactionState, oldViewState }) => {
    setViewState(viewState);
    if (externalOnViewStateChange) {
      // Incluir dimensiones en el viewState para cálculo de bbox
      const viewStateWithDimensions = {
        ...viewState,
        width: dimensions.width,
        height: dimensions.height
      };
      externalOnViewStateChange({ viewState: viewStateWithDimensions, interactionState, oldViewState });
    }
  };

  return (
    <div ref={containerRef} style={{ width: '100%', height: '100%' }}>
      <DeckGL
        ref={ref}
        viewState={viewState}
        onViewStateChange={onViewStateChange}
        glOptions={{ antialias: true }}
        layers={layers}
        deviceProps={{
          type: 'webgpu',
        }}
        parameters={parameters}
        controller={{
          touchZoom: true,
          touchRotate: true,
          dragPan: true,
          dragRotate: false,
          keyboard: false,
          orthographic: true,
        }}
      >
        <Map
          mapStyle="mapbox://styles/mapbox/light-v9"
          mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
        />
      </DeckGL>
    </div>
  );
}
